import type { PaymentMethod } from '~/common/enums/payments.enum';
import { PAYMENT_TYPE_TO_METHOD, PaymentType } from '~/common/enums/payments.enum';
import { depositPaymentTypeOptions } from '~/domains/payments/constants';
import type { useAvailablePaymentMethods } from '~/domains/payments/hooks/useAvailablePaymentMethods';

type AvailablePaymentMethods = ReturnType<
  typeof useAvailablePaymentMethods
>['availablePaymentMethods'];

type FilterDepositPaymentTypesInput = {
  availablePaymentMethods: AvailablePaymentMethods;
  showVIPP: boolean;
  showVenmo: boolean;
  disabledPaymentMethods: { deposit: string[]; withdrawal: string[] };
};

export function filterDepositPaymentTypes({
  availablePaymentMethods,
  showVIPP,
  showVenmo,
  disabledPaymentMethods,
}: FilterDepositPaymentTypesInput): PaymentType[] {
  return depositPaymentTypeOptions
    .filter((option) => {
      const availablePaymentMethod = availablePaymentMethods?.find(
        (method) => method.paymentMethod === (option as unknown as PaymentMethod) // `availablePaymentMethods` is keyed by PaymentMethod while the tiles iterate PaymentType; the existing filter relies on the two enums sharing member names, and retyping it is out of scope (Appendix B)
      );

      if (!availablePaymentMethod) {
        return false;
      }

      return availablePaymentMethod.status !== 'hidden';
    })
    .filter((option) =>
      showVIPP
        ? option !== PaymentType.PAPER_CHECK
        : ![PaymentType.PAPER_CHECK, PaymentType.VIPPREFERRED].includes(option)
    )
    .filter((option) => showVenmo || option !== PaymentType.VENMO)
    .filter((option) => !disabledPaymentMethods.deposit.includes(PAYMENT_TYPE_TO_METHOD[option]));
}
